import React, {useState, useEffect} from 'react'
import { Dialog, Grid, Grow, Icon, IconButton, makeStyles } from '@material-ui/core';
import ModalBase from '../../../../../components/Modals/ModalBase';
import DisplayText from '../../../../../components/Texts/DisplayText';
import LineInputText from '../../../../../components/Inputs/LineInputText/LineInputText';
import LineInputSelect from '../../../../../components/Inputs/LineInputSelect/LineInputSelect';
import { generalCatalogs } from '../../../../../variables/catalogs';
import { RoundedButton } from '../../../../../components/Buttons/GeneralButtons';



const Transition = React.forwardRef(function Transition(props, ref) {
    return <Grow  ref={ref} {...props} timeout={500}/>;
});

const useStyles = makeStyles(theme => ({
    root:{
        position:'relative'
    },
    buttonContainer:{
        marginTop:32
    }
}))

const AddRegisterModal = props => {

    const classes = useStyles()
    const {open, onClose, onAddItem} = props
    const [form, setForm] = useState(JSON.parse(JSON.stringify(formData)))
    const [valid, setValid] = useState(false)

    useEffect(() => {
        if(open) setForm(JSON.parse(JSON.stringify(formData)))
    }, [open])



    const onInputChange = (data) => {
        const id = data.config.id;
        let temp = {...form};
        temp[id] = {...data};
        setValid(validationForm(temp))
        setForm(temp)
    }

    const validationForm = (data) => {
        let isValid = true;
        Object.keys(data).forEach((item) => {if(data[item].isRequired && !data[item].isValid) isValid = false})
        return isValid;
    }

    const onSubmit = () => {
        if(valid) onAddItem(form)
    }

    return(
        <ModalBase open={open} onClose={onClose}>
            <div className={classes.root}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <DisplayText variant='h6'>Añadir vehículo</DisplayText>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <LineInputText
                                data={form.name}
                                onChange={onInputChange}/>
                            </Grid>
                            <Grid item xs={12}>
                                <LineInputSelect
                                data={form.type_id}
                                onChange={onInputChange}/>
                            </Grid>
                            <Grid item xs={12}>
                                <LineInputSelect
                                data={form.car_range_id}
                                onChange={onInputChange}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <div className={classes.buttonContainer}>
                            <Grid container justify='flex-end'> 
                                <Grid item>
                                    <RoundedButton label='Agregar' onClick={onSubmit}/>
                                </Grid>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </div>
        </ModalBase>
    )
}

export default AddRegisterModal

const formData = {
    name:{
        value: null,
        error: false,
        isVisited: false,
        isRequired: false,
        isValid: false,
        config:{
          id:'name',
          type:'text',
          fullWidth: true,
          label:'Nombre',
          placeholder:'Ingrese un nombre para identificar el vehículo...'
        },
        rules:{type:'distance'}
    },
    type_id:{
        value: null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        options:[...generalCatalogs.car_types ],
        config:{
          id:'type_id',
          type:'select',
          fullWidth: true,
          label:'Tipo',
          placeholder:'Seleccione una opción...'
        },
        rules:{
          type:'select',
        }
    },
    car_range_id:{
        value: null,
        error: false,
        isVisited: false,
        isRequired: true,
        isValid: false,
        options:[...generalCatalogs.car_ranges ],
        config:{
          id:'car_range_id',
          type:'select',
          fullWidth: true,
          label:'Rango',
          placeholder:'Seleccione una opción...'
        },
        rules:{
          type:'select',
        }
    },
}